import { PreloadedIconKey, preloadedIcons } from '@/_config/icons';
import { MouseEventHandler } from 'react';
import { errorReport } from '@/_helper/errorReport';

interface IconProps {
    name: PreloadedIconKey;
    size?: number;
    className?: string;
    color?: string;
    ariaLabel?: string;
    role?: string;
    onClick?: MouseEventHandler<SVGSVGElement>;
    ariaHidden?: boolean;
    ariaDescribedBy?: string;
}
export const Icon = ({
    name,
    size = 24,
    ariaLabel,
    color = 'currentColor',
    className = '',
    onClick,
    ariaHidden = false,
    ariaDescribedBy = '',
    role = 'img',
}: IconProps) => {
    // Fallback in case I missed an icon
    if (!isPreloadedIconKey(name)) {
        errorReport(new Error(`Icon ${name} not found`));
        console.log(`Icon ${name} not found`);
        return;
    }

    const IconComponent = preloadedIcons[name];

    return (
        <IconComponent
            role={role}
            aria-label={ariaLabel}
            fill={color}
            className={className}
            width={size}
            height={size}
            onClick={onClick}
            aria-hidden={ariaHidden}
            aria-describedby={ariaDescribedBy}
        />
    );
};

function isPreloadedIconKey(key: string): key is PreloadedIconKey {
    return Object.keys(preloadedIcons).includes(key);
}
export default Icon;
